import { ReactNode } from 'react';
import cn from 'classnames';

import styles from './SelectField.module.scss';

interface ISelectFieldProps {
  titleContent: ReactNode;
  titleClassName?: string;
  elementsContent: ReactNode;
}

export const SelectField = ({ titleContent, titleClassName = '', elementsContent }: ISelectFieldProps) => (
  <div className={styles.Container}>
    <div className={cn(styles.Title, titleClassName)}>{titleContent}</div>
    <div className={styles.SelectField}>{elementsContent}</div>
  </div>
);
